module.exports = __webpack_public_path__ + "img/ojpj-slider-img-2.719f8b51.png";